import React from 'react';
import T from 'prop-types';
import { LazyLoadImage } from '../Image';
import classnames from 'classnames';
import FormatDateTime from '../FormatDateTime';
import HeadingElement from './heading';

const propTypes = {
  Heading: T.string,
  Url: T.string,
  Date: T.string,
  Text: T.string,
  Image: T.string,
};

const Item = (props) => {
  const { Image, Heading, Url, Date, Text } = props;

  const infoType = `search-list__type--${props.item.InformationType}`;
  const classNames = classnames({
    'search-list__item': true,
    'search-list__item--has-img': Boolean(Image),
    [infoType]: props.item.InformationType,
  });

  return (
    <li className={classNames}>
      {Image && (
        <LazyLoadImage
          {...props}
          ImageUrl={Image}
          isBackgroundImage={true}
          DefaultPreset={{ name: 'preset_600' }}
          Sizes={{
            sizes:
              '(min-width: 1025px) 500px, (min-width: 640px) calc(100vw / 2) , 100vw',
          }}
        />
      )}
      <div className="search-list__content">
        {props.item.Vignette && (
          <span className="search-list__vignette">{props.item.Vignette}</span>
        )}
        {Date && <FormatDateTime date={Date} />}
        {
          <HeadingElement
            level={props.isMemberOfChapterContainer ? 4 : 3}
            className="search-list__title"
          >
            <a href={Url}>{Heading}</a>
          </HeadingElement>
        }
        {Text && <p className="search-list__text">{Text}</p>}
      </div>
    </li>
  );
};

Item.propTypes = propTypes;

export default Item;
